module.exports = __webpack_public_path__ + "img/single_video_2.e05e56bd.png";